export default {
  select_size: 'Valitse koko',
  required: 'Pakollinen',
  required_missing: 'Pakollinen — tee valinta',
  optional: 'Valinnainen',
  select_up_to: 'Valitse enintään {{maxCount}}',
};
